export enum WelcomePackHttpPaths {
  primaryAddress = '/api/v1.0/staff/addresses/primary',
  welcomePackStatus = '/api/v1.0/staff/welcome-pack',
  shiftsCount = '/api/v1.0/staff/shifts/summaries/count',
  // todo add proper path after be release
  availableShifts = '/api/v1.0/staff/shifts/available',
}
